<aipb-report [reportItemBody]="reportDataItem"></aipb-report>

<aipb-inside-loading [loading]="loading$ | async"></aipb-inside-loading>
